import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router";

import moment from "moment";

import SpecialIns from "../layout/Modals/SpecialInstrucModal";
import Spinner from "../../shared/spinner/Spinner";
import { get, handleError } from "../../shared/HttpReq";
import { Toast } from "../../shared/toaster/Toaster";

import Auth from "../../auth/Auth";
import AppContext from "../../shared/AppContext";

import PeopleLogo from "../../assests/images/People_Icon.svg";
import ArrowBack from "../../assests/images/Vector5.png";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
// import { useForm } from "../../shared/useForm";

function CartDetails(props) {
  const { setCompanyInfo } = useContext(AppContext);
  const route = useHistory();
  const { setCartValue, tip, setTip } = useContext(AppContext);
  const [isLoading, setLoading] = useState(false);
  const [toaster, SetToaster] = useState({
    show: false,
    type: "", // type should be "danger" or "success"
    content: "",
  });

  const [openModal, setOpenModal] = useState(false);

  const [cartItemData, setCarditemData] = useState({
    liability: false,
    min: 0,
    max: 0,
    heightmax: "",
    heightmin: "",
    weightmax: "",
    weightmin: "",
  });
  // const BookingDate=moment(Date.parse(date)).format("MM-DD-YYYY");
  const [cartDetails, setCartDetails] = useState([]);
  const [cardFinaldetail, setCardFinalPrice] = useState(0);
  const [cardFinaltip, setCardFinalTip] = useState(0);

  const [terms, setSelectedTime] = useState("");
  const [isChecked, setIsChecked] = useState([]);
  const [showError, setError] = useState([]);

  const [tipChecked, setTipChecked] = useState({});

  const params = useParams();

  //for set any special instruction
  const [anySpecialInstruction, setAnySpecialInstruction] = useState(false);

  function selectTimeslot(e, i, id) {
    let tempAry = [];
    let hash = { id: id, checked: e.target.checked };
    tempAry.push(hash);
    setIsChecked(tempAry);
    // debugger
    setCartDetails((pre) => {
      return [
        ...pre.map((itm) => {
          // itm.isSpecInsOpen = false;

          if (itm._id === id) {
            itm.term = e.target.checked;
            itm.excursion.special = !e.target.checked;
          }
          const element = pre.find((value) => {
            return value.excursion.special === true;
          });
          if (element) {
            setAnySpecialInstruction(true);
          } else {
            setAnySpecialInstruction(false);
          }
          return itm;
        }),
      ];
    });
    if (e.target.checked) {
      setError((prevState) => [...prevState, id]);
    } else {
      setError((prevState) => prevState.filter((itm) => itm !== id));
    }

    setSelectedTime(e.target.checked);
  }

  const getCardDetail = async () => {
    setLoading(true);
    let res = await handleError(
      await fetch(
        `${process.env.REACT_APP_BASE_URL}/cart/${params?.companyId}`,
        await get()
      )
    );

    if (res.length > 0) {
      setCompanyInfo({ name: res[0].company.name });
    }

    if (res.status === 200) {
      setLoading(false);
      var totalExcursionPrice = 0;

      setCartValue({ count: res.length });

      res.forEach((element) => {
        element.excursion.special = element.excursion.instructions
          ? true
          : false;
        var cost = 0;
        element.term = false;
        element.category.filter((e1) =>
          element.excursion.pricing.forEach((e2) => {
            if (e1.type === e2.type) {
              e2.priceValue = e1.count * e2.price;
              cost = cost + e2.priceValue;
            }
          })
        );
        element.totalPrice = cost;
        element.tipInfo = [
          {
            type: "checkbox",
            percentage: 10,
            value: Number(((element.totalPrice * 10) / 100).toFixed(2)),
            checked: false,
          },
          {
            type: "checkbox",
            percentage: 20,
            value: Number(((element.totalPrice * 20) / 100).toFixed(2)),
            checked: false,
          },
          {
            type: "checkbox",
            percentage: 30,
            value: Number(((element.totalPrice * 30) / 100).toFixed(2)),
            checked: false,
          },
          {
            type: "text",
            value: 0,
            percentage: 0,
            checked: false,
          },
        ];
        totalExcursionPrice = totalExcursionPrice + element.totalPrice;
      });

      // Tip checker.
      res.map((v) => setTipChecked((prev) => ({ ...prev, [v._id]: 0 })));
      const element = res.find((value) => {
        return value.excursion.special === true;
      });

      if (element) {
        setAnySpecialInstruction(true);
      } else {
        setAnySpecialInstruction(false);
      }

      setCardFinalPrice(totalExcursionPrice);

      // Holding tip as per requirement.
      if (tip.length > 0) {
        res.forEach((cart) => {
          console.log({ cart });
          for (const data of tip) {
            const key = Object.keys(data);
            if (cart._id == key) {
              cart.tipInfo = data[key];
              for (const tip of data[key]) {
                if(tip.checked==true){
                  setTipChecked((prev)=>({ ...prev, [cart._id]: tip.value }))
                }
              }
            }
          }
        });
        console.log({ inside: res });
        setCartDetails(cartDetails);
      }
      setCartDetails(res);
    } else {
      setLoading(false);
      SetToaster({
        show: true,
        type: "danger",
        content: res.message,
      });
    }
    // setLoading(false);
    // setTimeout(() => {
    //   SetToaster({
    //     show: false,
    //     type: "",
    //     content: "",
    //   });
    // }, 5000);
    // setLoading(false);
  };

  // Calculate the tip as per percentage.
  function tipCountHandler(value, id) {
    setCartDetails(
      cartDetails.map((cart) => {
        if (cart._id === id) {
          return {
            ...cart,
            tipInfo: cart.tipInfo.map((tip) => {
              console.log({ tip, value });
              if (tip.value == value) {
                tip.checked = !tip.checked;
              } else if (tip.type == "text") {
                tip.checked = false;
                tip.value = 0;
              } else {
                tip.checked = false;
              }
              return tip;
            }),
          };
        }
        return cart;
      })
    );

    // unchecked the same value
    setTipChecked((prev) => ({
      ...prev,
      [id]: tipChecked[id] === value ? 0 : value,
    }));
  }

  //get final tip value
  function getFinalTip() {
    setCardFinalTip(
      cartDetails.reduce((initialValue, obj) => {
        if (obj.tip) {
          initialValue += obj.tip;
        }

        return initialValue;
      }, 0)
    );
  }

  const updateCartDetail = (tipInfo, type, value, id) => {
    tipInfo.forEach((obj) => {
      if (obj.type == type) {
        obj.checked = true;
        obj.value = value;
      } else {
        obj.checked = false;
      }
    });

    setCartDetails((cart) => {
      return cart.map((item) => {
        if (item._id === id) {
          item.tipInfo = tipInfo;
        }
        return item;
      });
    });
  };

  // Handle custom tip
  const handleTip = (e, id, tipInfo, type) => {
    const value = Number(e.target.value);
    setTipChecked((prev) => ({ ...prev, [id]: value < 1 ? 0 : value }));
    updateCartDetail(tipInfo, type, value, id);
  };
  //remove excursion code

  const RemoveExcursion = async (e, id) => {
    setLoading(true);
    e.preventDefault();

    let res = await fetch(`${process.env.REACT_APP_BASE_URL}/web/cart/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-token": Auth.getToken(),
      },
    });
    if (res.status === 200) {
      getCardDetail();
      setLoading(false);
    }
  };

  let totalAmount =
    cardFinaldetail +
    cartDetails[0]?.company?.service_fee * cartDetails?.length +
    cardFinaltip;

  const specialInstructions = async () => {
    // e.preventDefault();
    let data = [];

    for (let i = 0; i < cartDetails.length; i++) {
      // debugger;
      const excusrion = {
        company: cartDetails[i].company._id || "",
        excursion: cartDetails[i].excursion._id || "",
        // date:
        //   moment(Date.parse(cartDetails[i].bookedTo)).format("YYYY-MM-DD") ||
        //   "",
        date: cartDetails[i].bookedTo.split("T")[0],
        time: cartDetails[i].time || "",
        category: cartDetails[i].category || "",
        notes: cartDetails[i]?.spection_instructions?.notes,
        beginnerCount: cartDetails[i]?.spection_instructions?.beginnerCount,
        initials: cartDetails[i]?.spection_instructions?.initials,
        fullName: cartDetails[i]?.spection_instructions?.fullName,
        acceptTerms: "yes",
        tip: tipChecked[cartDetails[i]._id] || "",
      };

      var tmparray = [];
      var hash = {
        id: cartDetails[i].company._id,
        acceptTerms: "yes",
      };

      tmparray.push(hash);

      if (cartDetails[i].excursion.instructions) {
        tmparray.forEach((a) => {
          excusrion.acceptTerms = "yes";
        });
      } else {
        excusrion.acceptTerms = "no";
      }

      data.push(excusrion);
    }

    const bookingData = {
      data,
      bookedFrom: "web",
    };

    setLoading(true);

    let res = await fetch(`${process.env.REACT_APP_BASE_URL}/booking`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-token": Auth.getToken(),
      },
      body: JSON.stringify(bookingData),
    });

    if (res.status >= 200 && res.status <= 299) {
      const data = await res.json();
      setLoading(false);
      route.push({
        pathname: "/PaymentDetails/" + data.orderId,
        state: totalAmount,
      });

      // localStorage.clear();

      return data.orderId;
    }

    if (res.status === 422) {
      const data = await res.json();
      setLoading(false);
      SetToaster({
        show: true,
        type: "danger",
        content: data[Object.keys(data)[0]].message,
      });
    }

    if (res.status === 400) {
      const data = await res.json();
      setLoading(false);
      SetToaster({
        show: true,
        type: "danger",
        content: data.message,
      });
    }

    // setTimeout(() => {
    //   SetToaster({
    //     show: false,
    //     type: "",
    //     content: "",
    //   });
    // }, 5000);
    // setLoading(false);
  };

  const checkOut = async (e) => {
    e.preventDefault();

    let checklab = {
      liability: "",
    };

    let findKey = JSON.parse(localStorage.getItem("_modaldetails"));

    cartDetails.forEach((cardDtl) => {
      let keyCheck;
      if (findKey) {
        keyCheck = findKey.find((element) => element._id === cardDtl._id);
      }

      if (!keyCheck) {
        if (cardDtl.excursion.liability) {
          checklab = cardDtl.excursion;
        }
      }
    });

    if (cartItemData.instructions) {
      alert("Please add special instructions of " + checklab.name);
      return;
    }

    if (anySpecialInstruction) {
      return;
    } else {
      if (
        cartDetails?.filter(
          (elem) =>
            elem.excursion.instructions === true &&
            elem.isSpecInsOpen === false &&
            elem.term
        ).length
      ) {
        alert("Please fill special instructions & accept all T&C form");
        return;
      } else {
        specialInstructions();
        // localStorage.clear();
      }
    }

    loop();
  };

  const loop = () => {
    // debugger
    for (let i = 0; i <= cartDetails.length; i++) {
      isChecked.forEach((check) => {
        if (cartDetails[i]?._id === check.id) {
          setSelectedTime(true);
        } else {
          setSelectedTime(false);
        }
      });
    }
  };

  // console.log("bookingData",bookingData);

  // const checkOutDisabledHandler = () => {
  // setCartDetails((pre) => {
  //   return [
  //     pre
  //       .map((cartItem) => cartItem._id)
  //       .sort()
  //       .toString() === showError.sort().toString(),
  //   ];
  // });
  // };

  useEffect(() => {
    const localData = JSON.parse(localStorage.getItem("_modaldetails"));
    if (localData) {
      const localIDs = localData.map((ld) => ld._id);
      setCartDetails((preDetails) => {
        return preDetails.map((cd) => {
          return {
            ...cd,
            isSpecInsOpen: localIDs.indexOf(cd._id) >= 0,
            spection_instructions: localData[localIDs.indexOf(cd._id)],
          };
        });
      });
    }
  }, [openModal]);

  useEffect(() => {
    getFinalTip();

    // eslint-disable-next-line
  }, [cartDetails]);

  useEffect(() => {
    getCardDetail();
  }, [params?.companyId]);

  useEffect(() => {
    if (!Auth.isUserAuthenticated()) {
      route.push("/");
    }
  }, [route]);

  useEffect(() => {
    localStorage.removeItem("_modaldetails");
  }, []);

  useEffect(() => {
    console.log("ahhgdhsgdhsdghsdg");
    const data = cartDetails.map((v) => ({ [v._id]: v.tipInfo }));
    data.length > 0 && setTip(data);
  }, [tipChecked]);

  console.log({ cartDetails, tip });
  // route.push("/CartDetails/" + params.companyId + "/" + params.excursionId + '?date=' + query.get("date"))
  return (
    <>
      {isLoading ? <Spinner /> : null}
      <Toast
        show={toaster.show}
        type={toaster.type}
        content={toaster.content}
        onClose={() =>
          SetToaster({
            show: false,
            type: "",
            content: "",
          })
        }
      />
      <div className="container">
        <div className="card_details">
          <div className="mb-5 d-flex align-items-center justify-content-between">
            <p onClick={() => route.goBack()} className="backbtn">
              <img src={ArrowBack} alt="" className="" /> Back
            </p>
            <button className="continue_shopping_btn blue-bg" type="button" onClick={()=>route.push(`/?id=${Auth.getCompanyHexaID()}`)}>Continue Shopping</button>
          </div>
          <div className="card_details_heading_top">
            <h4 className="everyday_color">Cart Details</h4>
          </div>

          <div className="crad_details_container row">
            <div className="col-lg-7 col-md-12">
              {cartDetails.length === 0 ? (
                <div className="d-flex justify-content-center align-items-center no_data">
                  <h1>Currently your cart is empty</h1>
                </div>
              ) : null}

              {cartDetails.length
                ? cartDetails.map((cart, index) => (
                    <div
                      className="filling_date_col position-relative"
                      key={index}
                    >
                      <button
                        className="delete_exursion"
                        onClick={(e) => RemoveExcursion(e, cart._id)}
                      >
                        <svg width="25" height="25" viewBox="0 0 25 25">
                          <defs></defs>
                          <g transform="translate(-680 -168)">
                            <circle
                              style={{ fill: "#4E74F6" }}
                              cx="12.5"
                              cy="12.5"
                              r="12.5"
                              transform="translate(680 168)"
                            />
                            <g transform="translate(687.243 156.151) rotate(45)">
                              <path
                                style={{
                                  fill: "none",
                                  stroke: "#fff",
                                  strokeLinecap: "square",
                                  strokeWidth: "1.3px",
                                }}
                                d="M27,11H14"
                                transform="translate(0 2.5)"
                              />
                              <path
                                style={{
                                  fill: "none",
                                  stroke: "#fff",
                                  strokeLinecap: "square",
                                  strokeWidth: "1.3px",
                                }}
                                d="M18,7V20"
                                transform="translate(2.5 0)"
                              />
                            </g>
                          </g>
                        </svg>
                      </button>

                      <div className="top_section d-flex">
                        <div className="img_container d-flex">
                          <img
                            src={
                              cart.excursion
                                ? `${process.env.REACT_APP_BASE_URL}/media/?file=${cart.excursion.image}`
                                : ""
                            }
                            alt=""
                            className="img_visit_place"
                          />
                          <div className="img_content">
                            <div className="img_heading">
                              <h4 className="everyday_color">
                                {cart.excursion ? cart.excursion.name : "0"}
                              </h4>
                            </div>
                          </div>
                        </div>
                        <div className="price_top">
                          <span className="price">
                            <strong>
                              $
                              {cart.totalPrice ? cart.totalPrice.toFixed(2) : 0}
                            </strong>
                          </span>
                        </div>
                      </div>
                      <div className="fillingdate-participants_container d-flex justify-content-between">
                        <div className="filling_date-container">
                          <div className="mt-0">
                            <label htmlFor="#" className="cartlable">
                              Date :
                            </label>
                            <span className="exursion_date">
                              {moment(cart.bookedTo.split("T")[0]).format(
                                "MM-DD-YYYY"
                              )}

                              {/* {" "}
                              {cart.bookedTo.split("T")[0]} */}
                              {/* {moment.utc(cart.bookedTo).local().format("MM-DD-YYYY")} */}
                            </span>
                          </div>
                          <div className="custom_cart_top_margin">
                            <label htmlFor="#" className="cartlable">
                              Start Time :
                            </label>
                            <span className="exursion_date">
                              {" "}
                              {/* {moment(cart.time, ["h:mm A"]).format("HH:mm")} */}
                              {moment(cart.time, ["HH:mm"]).format("h:mm A")}
                            </span>
                          </div>
                        </div>
                        <div className="participants-container">
                          <h5>Participants</h5>

                          {cart.category.length
                            ? cart.category.map((item, index) =>
                                item.count === 0 ? (
                                  " "
                                ) : (
                                  <div
                                    className="participants_con d-flex"
                                    key={index}
                                  >
                                    <img src={PeopleLogo} alt="" />
                                    <b
                                      style={{
                                        marginLeft: "7px",
                                        marginRight: "-10px",
                                        marginTop: "3px",
                                      }}
                                    >
                                      {item.count}
                                    </b>

                                    <span className="vector everyday_color ">
                                      {item.type} -{" "}
                                      <strong>
                                        $
                                        {
                                          cart.excursion.pricing.filter(
                                            (v) => v.type === item.type
                                          )[0]?.priceValue
                                        }
                                      </strong>
                                    </span>
                                  </div>
                                )
                              )
                            : null}
                        </div>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                      <p className="everyday_color service_charges">Service Fee</p>
                      <div className="align-self-center total_adventure_price">
                          <span className="price everyday_color tiprice tiprate">
                            ${cart.company.service_fee}
                          </span>
                        </div>
                        </div>
                      <div className="tip everyday_color mb-0 tiprate d-flex justify-content-between">
                        <div className="tip_box_container d-flex ">
                          <div className="d-flex align-items-center">
                            <p className="fp custom-margin-left">Tip</p>
                            {cart.tipInfo.map((tip) => (
                              <div className="form-group space-manage">
                                {tip.type == "checkbox" ? (
                                  <div className="position-relative">
                                    <input
                                      type="checkbox"
                                      className="tip_box fp blue-bg"
                                      id={`ten-${cart._id}`}
                                      value={tip.value}
                                      checked={tip.checked}
                                      // name={`tip-${cart._id}`}
                                      onChange={(e) =>
                                        tipCountHandler(
                                          e.target.value,
                                          cart._id,
                                          tip
                                        )
                                      }
                                    />
                                    <label
                                      htmlFor={`ten-${cart._id}`}
                                      className="precenlable"
                                    >
                                      {tip.percentage}%
                                    </label>
                                  </div>
                                ) : (
                                  <input
                                    type="number"
                                    name="tip"
                                    min={0}
                                    className="input-txt_tip"
                                    value={
                                      tip.value > 0 ? Number(tip.value) : ""
                                    }
                                    onChange={(e) =>
                                      handleTip(
                                        e,
                                        cart._id,
                                        cart.tipInfo,
                                        "text"
                                      )
                                    }
                                    placeholder="Enter Custom Tip Here"
                                  />
                                )}
                              </div>
                            ))}
                          </div>
                        </div>

                        <div className="align-self-center total_adventure_price">
                          <span className="price everyday_color tiprice">
                            {/* ${cart.tip ? cart.tip.toFixed(2) : 0} */}$
                            {tipChecked[cart._id]
                              ? Number(tipChecked[cart._id]).toFixed(2)
                              : 0}
                          </span>
                        </div>
                      </div>
                      <div className="term_conditions d-flex mt-5 mb-3">
                        {cart.excursion.instructions === true && (
                          <label className="control mb-0">
                            {cart?.term}
                            <input
                              type="checkbox"
                              id="terms"
                              value={cart.term}
                              checked={cart.term}
                              onChange={(e) =>
                                selectTimeslot(e, index, cart._id)
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                        )}
                        {cart.excursion.instructions === true && (
                          <span
                            className={
                              cart.isSpecInsOpen
                                ? "text-success"
                                : "termcond_text"
                            }
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              cart.excursion.instructions === true
                                ? setOpenModal(true)
                                : setOpenModal(false);
                              setCarditemData({
                                id: cart._id,
                                liability: cart.excursion.liability,
                                min: cart.excursion.min,
                                max: cart.excursion.max,
                                heightmax: cart?.excursion?.heightMax
                                  ? cart?.excursion?.heightMax
                                  : "",
                                heightmin: cart?.excursion?.heightMin
                                  ? cart?.excursion?.heightMin
                                  : "",
                                weightmax: cart?.excursion?.weightMax
                                  ? cart?.excursion?.weightMax
                                  : "",
                                weightmin: cart?.excursion?.weightMin
                                  ? cart?.excursion?.weightMin
                                  : "",
                              });

                              // selectTimeslot({})
                            }}
                          >
                            Any special instructions *
                          </span>
                        )}
                      </div>
                      {cart.excursion.instructions === true && (
                        <div>
                          {showError?.indexOf(cart._id) >= 0 ? null : (
                            <span className="text-danger">
                              Please accept the special instructions in order to
                              continue.
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  ))
                : null}
            </div>

            <div className="col-lg-5 col-md-12">
              <div className="checkout_col">
                <p className="price_total">Total</p>
                <div className="checkout_wrapper">
                  <div className="price_top d-flex everyday_color">
                    <p className="fp">Price :</p>
                    <span className="price">
                      ${cardFinaldetail ? cardFinaldetail.toFixed(2) : 0}
                    </span>
                  </div>

                  <div className="tip everyday_color d-flex">
                    <p className="fp">Tip</p>
                    <div className="tip_box_container">
                      <span className="price everyday_color">
                        $
                        {Object.values(tipChecked).reduce(
                          (accumulator, currentValue) => {
                            accumulator =
                              Number(accumulator) + Number(currentValue);
                            return accumulator.toFixed(2);
                          },
                          0
                        )}

                        {console.log("tip toal",Object.values(tipChecked).reduce(
                          (accumulator, currentValue) => {
                            accumulator =
                              Number(accumulator) + Number(currentValue);
                            return accumulator.toFixed(2);
                          },
                          0
                        ))}
                      </span>
                    </div>
                  </div>
                  <div className="service everyday_color d-flex">
                    <p className="fp">Service Charge:</p>
                    <span className="price">
                      $
                      {cartDetails.length
                        ? (
                            cartDetails[0].company.service_fee *
                            cartDetails?.length
                          ).toFixed(2)
                        : 0}
                    </span>
                  </div>
                  {/* <div className="service everyday_color d-flex">
                    <p className="fp">Payment Handling Fees:</p>
                    <span className="price">
                      ${" "}
                      {cartDetails.length
                        ? (
                            cartDetails[0].company.service_fee *
                            cartDetails?.length
                          ).toFixed(2)
                        : 0}
                    </span>
                  </div> */}

                  <div className="totle_checkout d-flex">
                    <div className="totle_price">
                      $
                      {cartDetails.length
                        ? (
                            cardFinaldetail +
                            cartDetails[0]?.company?.service_fee *
                              cartDetails?.length +
                            Object.values(tipChecked).reduce(
                              (accumulator, currentValue) =>
                                Number(accumulator) + Number(currentValue),
                              0
                            )
                          ).toFixed(2)
                        : 0}
                    </div>
                    <div className="checkout_btn">
                      <button
                        className="active blue-bg"
                        color="primary"
                        onClick={(e) => {
                          checkOut(e);
                        }}
                        // disabled={showError.length !== 0}
                      >
                        Checkout
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {openModal && (
            <SpecialIns
              closeModal={setOpenModal}
              cartItemData={cartItemData}
              cardData={cartDetails}
              totalAmount={
                cardFinaldetail +
                cartDetails[0]?.company?.service_fee * cartDetails?.length +
                cardFinaltip
              }
            />
          )}
        </div>
      </div>
    </>
  );
}

export default CartDetails;
